import React from "react";
import { Row, Col, Image, Container, Navbar, Nav} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import Logo_img from "../assets/images/shb-logo.svg";
import Logo_img_EN from "../assets/images/Logo-SHB-EN.png";
import UKImg from "../assets/images/multi-language-UK.svg";
import VNImg from "../assets/images/multi-language-VN.png";
import languages from "../components/common/languages";
import { useIntl, FormattedMessage } from 'react-intl';

const Header = (props) => {
    const intl = useIntl();
    const { onChangeLanguage, language } = props;
    return(
        <Row className={props.headerClassName}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{ paddingTop: '15px', paddingBottom: '15px' }}>
                <Navbar expand="lg" className="text-menu">
                    <Container className="container-collapse">
                        <Navbar.Brand href="/dn/ib">
                            <Image src={language === languages.vi ? Logo_img : Logo_img_EN} className="img-logo"/>
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto">
                                <Nav.Link href="/dn/tracuubaolanh" target='_blank'><FormattedMessage  id={"menu_header_guarantee"}/></Nav.Link>
                                <Nav.Link href="https://www.shb.com.vn/mangluoi/mang-luoi-hoat-dong/" target='_blank'><FormattedMessage  id={"menu_header_atm"}/></Nav.Link>
                                <Nav.Link href="/dn/DIEU KHOAN DIEU KIEN IBKHDN.pdf" target='_blank'><FormattedMessage  id={"menu_header_term_condition"}/></Nav.Link>
                                <Nav.Link href="https://www.shb.com.vn/category/khach-hang-doanh-nghiep/cac-san-pham-dich-vu-uu-dai/" target='_blank'><FormattedMessage  id={"menu_header_promotion"}/></Nav.Link>
                                {intl.locale === languages.vi ? 
                                    <Nav.Link onClick={()=>onChangeLanguage(languages.en)} href="#" >
                                        <Image src={UKImg}/>
                                    </Nav.Link> :
                                    <Nav.Link onClick={()=>onChangeLanguage(languages.vi)} href="#" >
                                        <Image src={VNImg} style={{width: '24px'}}/>
                                    </Nav.Link>
                                }
                                
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </Col>            
        </Row>
    );
}
export default Header;